import { createContext } from "react";
import type { AuftragMini, OrderDraft, OrderHistoryRow } from "@/lib/orders";

export type OrderWizardNoticeHandler = (message: string) => void;
export type OrderWizardChangedHandler = () => void;

export interface OpenNewOrderOptions {
  /** Projekt vorauswählen (z. B. aus der Projektübersicht). */
  auftrag?: AuftragMini;
}

export interface OrderWizardContextValue {
  openNew: (opts?: OpenNewOrderOptions) => void;
  openDraft: (draft: OrderDraft) => void;
  openDraftById: (id: number, title?: string) => Promise<void>;
  openEdit: (row: OrderHistoryRow) => Promise<void>;
  openDetail: (row: OrderHistoryRow) => void;
  openDetailByBestellnummer: (bestellnummer: string) => Promise<void>;
  closeDetail: () => void;
  beginReorder: (row: OrderHistoryRow, indices: number[] | null) => void;
  isOpen: boolean;
  subscribeNotice: (listener: OrderWizardNoticeHandler) => () => void;
  subscribeOrdersChanged: (listener: OrderWizardChangedHandler) => () => void;
}

export const OrderWizardContext = createContext<OrderWizardContextValue | null>(null);
